// extracted by mini-css-extract-plugin
export default {"mainContainer":"app_mainContainer__F2VV+","lowerSection":"app_lowerSection__KZxPf","divider":"app_divider__RRxik"};